import * as React from "react";

const MOBILE_BREAKPOINT = 768;

/**
 * A phone on its side: wide enough for the desktop breakpoint, but too short
 * for two panes and their chrome. Callers that lay out panes pass it as
 * `maxHeight`; CSS that must agree spells it `[@media(max-height:500px)]`.
 */
export const SHORT_VIEWPORT_MAX_HEIGHT = 500;

export function useIsMobile(
  breakpoint = MOBILE_BREAKPOINT,
  options: { maxHeight?: number } = {},
) {
  const { maxHeight } = options;
  const [isMobile, setIsMobile] = React.useState<boolean | undefined>(
    undefined,
  );

  React.useEffect(() => {
    const narrow = `(max-width: ${breakpoint - 1}px)`;
    const mql = window.matchMedia(
      maxHeight == null ? narrow : `${narrow}, (max-height: ${maxHeight}px)`,
    );
    const onChange = () => {
      setIsMobile(
        window.innerWidth < breakpoint ||
          (maxHeight != null && window.innerHeight <= maxHeight),
      );
    };
    mql.addEventListener("change", onChange);
    onChange();
    return () => mql.removeEventListener("change", onChange);
  }, [breakpoint, maxHeight]);

  return !!isMobile;
}
